import {Injectable} from '@angular/core';
import {AltProperties} from '@nh/angular-tses';

export enum DasAccessibilityItem {
  HEADER = 'header',
  HEADER_LOGO = 'headerLogo',
  HEADER_HOME = 'headerHome',
  HEADER_SEARCH = 'headerSearch',
  HEADER_HELP = 'headerHelp',
  HEADER_USER_MENU = 'headerUserMenu',
  HEADER_NEW_DEPARTURE = 'headerNewDeparture',
  HEADER_CONTACT_SUPPORT = 'headerContactSupport',

  SEARCH_BAR = 'searchBar',

  SEARCH_BAR_SEARCH = 'searchBarSearch',
  SEARCH_BAR_EXPORT = 'searchBarExport',
  SEARCH_BAR_COLUMNS = 'searchBarColumns',

  FILTER = 'filter',
  FILTER_WAITING = 'filterWaiting',
  FILTER_INVOLVED = 'filterInvolved',
  FILTER_ORGANISATIONS = 'filterOrganisations',
  FILTER_DISCIPLINES = 'filterDisciplines',
  FILTER_WITHDRAWN = 'filterWithdrawn',
  FILTER_ACTIONS = 'filterActions',

  DEPARTURE_LIST = 'departureList',

  PRIVACY_FOOTER = 'privacyFooter',
  PRIVACY_FOOTER_PRIVACY = 'privacyFooterPrivacy',
  PRIVACY_FOOTER_ACCESSIBILITY = 'privacyFooterAccessibility',
  PRIVACY_FOOTER_COOKIE = 'privacyFooterCookie',

  SIDEBAR = 'sidebar',
  SIDEBAR_REFERENCES = 'sidebarReferences',
  SIDEBAR_ATTACHMENTS = 'sidebarAttachments',
  SIDEBAR_GUIDANCE = 'sidebarGuidance',
  SIDEBAR_EXPORT = 'sidebarExport',
  SIDEBAR_SNAPSHOT = 'sidebarSnapshot',

  KEY_DATA = 'keyData',

  NAVIGATION = 'navigation',
  NAVIGATION_DEPARTURE_SUBMISSION = 'navigationDepartureSubmission',
  NAVIGATION_DEPARTURE_DIARY = 'navigationDepartureDiary',
  NAVIGATION_SPECIALIST_REVIEW = 'navigationSpecialistReview',
  NAVIGATION_DEPARTURE_POST_DETERMINATION = 'navigationDeparturePostDetermination',

  GLOBAL_FILTER = 'globalFilter',
  GLOBAL_FILTER_SAVED = 'globalFilterSaved',
  GLOBAL_FILTER_STATUS = 'globalFilterStatus',
  GLOBAL_FILTER_STANDARD = 'globalFilterStandard',
  GLOBAL_FILTER_PEOPLE = 'globalFilterPeople',
  GLOBAL_FILTER_LOCATION = 'globalFilterLocation',
  GLOBAL_FILTER_DEP_INFO = 'globalFilterDepInfo',
}

const DasAccessibilityKeys: Record<DasAccessibilityItem, AltProperties> = {
  header: {initialKey: 'h', key: null, condition: true},
  headerLogo: {initialKey: 'h', key: 'd', condition: true},
  headerHome: {initialKey: 'h', key: 'h', condition: true},
  headerSearch: {initialKey: 'h', key: 's', condition: true},
  headerHelp: {initialKey: 'h', key: 'w', condition: true},
  headerUserMenu: {initialKey: 'h', key: 'u', condition: true},
  headerNewDeparture: {initialKey: 'h', key: 'n', condition: true},
  headerContactSupport: {initialKey: 'h', key: 'c', condition: true},

  searchBar: {initialKey: 'q', key: null, condition: true},
  searchBarSearch: {initialKey: 'q', key: 's', condition: true},
  searchBarExport: {initialKey: 'q', key: 'e', condition: true},
  searchBarColumns: {initialKey: 'q', key: 'c', condition: true},

  filter: {initialKey: 'f', key: null, condition: true},
  filterWaiting: {initialKey: 'f', key: 'a', condition: true},
  filterInvolved: {initialKey: 'f', key: 'b', condition: true},
  filterOrganisations: {initialKey: 'f', key: 'c', condition: true},
  filterDisciplines: {initialKey: 'f', key: 'd', condition: true},
  filterWithdrawn: {initialKey: 'f', key: 'e', condition: true},
  filterActions: {initialKey: 'f', key: 'f', condition: true},

  departureList: {initialKey: 'd', key: null, condition: true},

  privacyFooter: {initialKey: 'p', key: null, condition: true},
  privacyFooterPrivacy: {initialKey: 'p', key: 'p', condition: true},
  privacyFooterAccessibility: {initialKey: 'p', key: 'a', condition: true},
  privacyFooterCookie: {initialKey: 'p', key: 'c', condition: true},

  sidebar: {initialKey: 's', key: null, condition: true},
  sidebarReferences: {initialKey: 's', key: 'r', condition: true},
  sidebarAttachments: {initialKey: 's', key: 'a', condition: true},
  sidebarGuidance: {initialKey: 's', key: 'g', condition: true},
  sidebarExport: {initialKey: 's', key: 'e', condition: true},
  sidebarSnapshot: {initialKey: 's', key: 's', condition: true},

  keyData: {initialKey: 'k', key: null, condition: true},

  navigation: {initialKey: 'n', key: null, condition: true},
  navigationDepartureSubmission: {initialKey: 'n', key: 's', condition: true},
  navigationDepartureDiary: {initialKey: 'n', key: 'd', condition: true},
  navigationSpecialistReview: {initialKey: 'n', key: 'r', condition: true},
  navigationDeparturePostDetermination: {initialKey: 'n', key: 'p', condition: true},

  globalFilter: {initialKey: 'g', key: null, condition: true},
  globalFilterSaved: {initialKey: 'g', key: 's', condition: true},
  globalFilterStatus: {initialKey: 'g', key: 't', condition: true},
  globalFilterStandard: {initialKey: 'g', key: 'a', condition: true},
  globalFilterPeople: {initialKey: 'g', key: 'p', condition: true},
  globalFilterLocation: {initialKey: 'g', key: 'l', condition: true},
  globalFilterDepInfo: {initialKey: 'g', key: 'i', condition: true},
};

@Injectable({
  providedIn: 'root',
})
export class AccessibilityKeysService {
  constructor() {}

  public getAltProperties(item: DasAccessibilityItem, condition: boolean = true): AltProperties {
    const altProperties = DasAccessibilityKeys[item];
    altProperties.condition = condition;
    return altProperties;
  }
}
